import React, { Component, Fragment } from "react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Card,
	Spin,
	Row,
	Button,
	Form,
	Popconfirm,
	Icon,
	message,
	Upload
} from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import { locationPrefix } from "common/general";
import { autorun } from "mobx";
import { inject, observer } from "mobx-react";
import AddEditAccountDialog from "./components/AddEditAccountDialog";

const FormItem = Form.Item;

function getTextFilter(type) {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for ' +
			type +
			"</div>" +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="' +
			type +
			'..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter ' +
			type +
			" that you want to search for</div>" +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			// console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

@inject("rootStore")
@observer
class AccountsPage extends Component {
	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: [
				{
					headerName: "Site",
					field: "siteName",
					editable: false,
					// filter: getTextFilter("Site"),
					filter: "agTextColumnFilter",
					headerCheckboxSelection: true,
					checkboxSelection: true
				},
				{
					headerName: "Email",
					field: "email",
					editable: false,
					filter: getTextFilter("Email")
				},
				{
					headerName: "Username",
					field: "username",
					editable: false,
					filter: getTextFilter("Username")
				},
				{
					headerName: "Password",
					field: "password",
					editable: false,
					suppressFilter: true
				}
			],
			rowSelection: "multiple"
		};
		return gridDefs;
	}

	deleteAccounts = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		if (this.gridApi != null) {
			let accountIds = [];
			for (let node of this.gridApi.getSelectedNodes()) {
				const account = node.data;
				accountIds.push({
					accountListId: account.accountListId,
					siteName: account.siteName,
					email: account.email
				});
			}
			accountsStore.remoteDeleteAccounts(accountIds);
		}
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	componentWillUnmount() {
		if (this.deleteAccountDisposer != null) {
			this.deleteAccountDisposer();
		}

		if (this.newAccountDisposer != null) {
			this.newAccountDisposer();
		}

		if (this.updateAccountDisposer != null) {
			this.updateAccountDisposer();
		}

		if (this.importAccountDisposer != null) {
			this.importAccountDisposer();
		}
	}

	showAddAccountDialog = () => {
		const {
			rootStore: { accountsStore }
		} = this.props;

		accountsStore.showAddAccountDialog();
	};

	onGridReady = params => {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;

		const {
			rootStore: { accountsStore }
		} = this.props;

		const ui = accountsStore.ui;

		this.deleteAccountDisposer = autorun(() => {
			if (ui.deletedAccounts != null) {
				this.gridApi.updateRowData({
					remove: ui.deletedAccounts
				});
			}
		});

		this.newAccountDisposer = autorun(() => {
			if (ui.newAccount != null) {
                const currentAccount = this.gridApi.getRowNode(
					ui.newAccount.siteName + "_" + ui.newAccount.email
                );
                
                if (currentAccount == null) {
                    this.gridApi.updateRowData({
                        add: [ui.newAccount]
                    });
                } else {
                    this.gridApi.updateRowData({
                        update: [ui.newAccount]
                    });                    
                }		 		
			}
		});

		this.updateAccountDisposer = autorun(() => {
			// console.log("Updated account");
			if (ui.updatedAccount != null) {
				this.gridApi.updateRowData({
					update: [ui.updatedAccount]
				});
			}
		});

		this.importAccountDisposer = autorun(() => {
			// console.log("Imported accounts");
			let updatedAccounts = [];
			let newAccounts = [];
			for (let account of ui.importedAccounts) {
				const currentAccount = this.gridApi.getRowNode(
					account.siteName + "_" + account.email
				);
				if (currentAccount == null) {
					newAccounts.push(account);
				} else {
					updatedAccounts.push(account);
				}
			}
			if (ui.importedAccounts != null) {
				this.gridApi.updateRowData({
					add: newAccounts,
					update: updatedAccounts
				});
			}
		});
	};

	render() {		
		const {
			rootStore: { accountsStore }
		} = this.props;

		const ui = accountsStore.ui;

		let breadcrumbList = "";

		let downloadAccountsHref = "";
		if (!ui.loadingAccounts) {
			breadcrumbList = [
				{
					title: "Home",
					href: locationPrefix + "/"
				},
				{
					title: "Campaigns",
					href: locationPrefix + "/"
				},
				{
					title: "Campaign",
					href: locationPrefix + "/campaign/" + accountsStore.campaign.id
				},
				{
					title: "Accounts"
				}
			];
			downloadAccountsHref =
				"/action/export/profile/" + accountsStore.profile.id;
		}

		let spinning = ui.loadingAccounts == true || ui.deletingAccounts == true;
		const gridDefs = this.createGridDefs();

		const props = {
			name: "file",
			action: "/action/import/profile/" + accountsStore.profile.id,
			showUploadList: false,
			onChange: (info) => {
				if (info.file.status == "uploading") {
					accountsStore.startImportingAccounts();
					return;
				}
				// if (info.file.status !== "uploading") {
				// 	console.log(info.file, info.fileList);
				// }
				if (info.file.status === "done") {						
					accountsStore.completeImportingAccounts();
					if (info.file.response && info.file.response.error) {
						message.error(info.file.response.error.message, 5);
						return;
					}
					message.success(`${info.file.name} file uploaded successfully`);					
				} else if (info.file.status === "error") {
					message.error(`${info.file.name} file upload failed.`);
					accountsStore.completeImportingAccounts();
				}
			}
		};

		return (
			<Fragment>
				{ui.loadingAccounts == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={"Account Profile: " + accountsStore.profile.name}
					>
                        <AddEditAccountDialog />
						<Card>
							<Spin spinning={spinning}>
								<Row>
									<Form layout="inline" style={{ marginBottom: 8 }}>
										<FormItem>
											<Button
												type="primary"
												onClick={this.showAddAccountDialog}
											>
												<Icon type="plus-square-o" />
											</Button>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Do you want to delete the selected accounts?"
												place
												ment="bottom"
												onConfirm={this.deleteAccounts}
											>
												<Button type="primary">
													<Icon type="delete" />
												</Button>
											</Popconfirm>
										</FormItem>
										<FormItem>
											<Upload {...props}>
												<Button type="primary" loading={ui.importingAccounts}>
													<Icon type="upload" />
												</Button>
											</Upload>
										</FormItem>
										<FormItem>
											<Button type="primary" href={downloadAccountsHref}>
												<Icon type="download" />
											</Button>
										</FormItem>
									</Form>
								</Row>
								<Row>
									<div
										style={{
											width: "100%",
											height: window.screen.height * 3 / 4
										}}
									>
										<div
											style={{
												boxSizing: "border-box",
												height: "100%",
												width: "100%"
											}}
											className="ag-theme-balham"
										>
											<AgGridReact
												columnDefs={gridDefs.columnDefs}
												enableColResize={true}
												enableFilter={true}
												floatingFilter={true}
												enableSorting={true}
												rowData={accountsStore.accounts}
												enableRangeSelection={true}
												rowSelection={gridDefs.rowSelection}
												suppressRowClickSelection={true}
												onRowSelected={this.onRowSelected}
												getRowNodeId={data => {
													return data.siteName + "_" + data.email;
												}}
												onSortChanged={e => {
													// console.log(e.api.getSortModel());
												}}
												deltaRowDataMode={true}
												onGridReady={this.onGridReady}
											/>
										</div>
									</div>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}

export default AccountsPage;
